module.exports = __webpack_public_path__ + "img/kong.ac748f97.png";